import { atom, selector } from "recoil";

// Modal Store Format 
// modalComp : ModalComponent
// props : Props
// ok : Ok Button EventHandler
// cancel : Cancel Button EventHandler

//Modal Stack State
export const modalState = atom({
  key: 'modalStateAtom',
  default: [],
});

//Modal Open/Close State
export const modalOpenState = selector({
  key: 'modalOpenStateAtom',
  get: ({ get }) => {
    return get(modalState).length !== 0;
  },
});

//Modal Header Count Info
export const modalCountState = atom({
  key : 'modalCountStateAtom',
  default : 0
})